/**
 * Class that defines generic messages used recurrently in different parts of the project
 */

export default class MessageUtils {
    static getGenericError(action, entity) {
        return `There was an error while ${action} the ${entity}`;
    }
}
